import { z } from "zod";

export const Parcel_Schema = z
  .object({
    trackingNumber: z.string(),
    trackingUrl: z.url(), // absolute URL expected
    deliveryTag: z.string().nullable(),
  })
  .transform(({ deliveryTag, ...rest }) => ({
    ...rest,
    dropOffCode: deliveryTag,
  }));
